// src/utils/userPresentation.js  (o donde quieras)
import { BASE_URL } from "../services/api";

export function getAvatarUrlFromUser(user) {
    if (!user) return "";

    const raw =
        user.avatar_url ||
        user.avatarUrl ||
        user.profile_image_url ||
        user.image_url ||
        "";

    if (!raw) return "";

    if (raw.startsWith("http://") || raw.startsWith("https://")) return raw;
    return `${BASE_URL}${raw}`;
}

export function getDisplayName(user) {
    return user?.name || user?.email || "";
}